import React from "react";
import "./arrow.scss";

type arrowProps = {
  direction: string;
  clickHandler: any;
  activeIndex: any;
  itemsLength: number;
};

const Arrow = ({ direction, clickHandler, activeIndex, itemsLength }: arrowProps) => {
  return (
    <div
      className={
        direction === "left"
          ? activeIndex === 0
            ? "arrow__disabled"
            : "arrow"
          : activeIndex === 4 || itemsLength === 1
            ? "arrow__disabled"
            : "arrow"
      }
      tabIndex={3}
      onClick={clickHandler}
      id={direction === "left" ? "left-arrow-button" : "right-arrow-button"}
    >
      <div
        className={
          direction === "left"
            ? activeIndex === 0
              ? "arrow__disabled-left"
              : "arrow__left"
            : activeIndex === 4 || itemsLength === 1
              ? "arrow__disabled-right"
              : "arrow__right"
        }
        tabIndex={4}
      ></div>
    </div>
  );
};

export default Arrow;
